// extracted by mini-css-extract-plugin
export default {"breadcrumb":"Boo0QYyQ6UoSPtXBRMVy","reportText":"kiUB_zEHBmfPiKCKQdEO","report":"d3qxR4uIU7YvvTCVBDPD"};